import { render } from "./PickUpQueueShow.vue?vue&type=template&id=5a10dbae"
import script from "./PickUpQueueShow.vue?vue&type=script&lang=js"
export * from "./PickUpQueueShow.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./PickUpQueueShow.vue?vue&type=style&index=1&id=5a10dbae&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__